var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "nav-bar-container" }, [
        _c("div", { staticClass: "nav-bar" }, [
          _c(
            "a",
            {
              on: {
                click: function ($event) {
                  return _vm.navBack()
                },
              },
            },
            [_vm._v("\n        < " + _vm._s(_vm.$i18n.t("back")) + "\n      ")]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "header-container" }, [
        _c("div", { staticClass: "header" }, [
          _c("span", { staticClass: "notice-header" }, [
            _vm._v("\n        " + _vm._s(_vm.title) + "\n      "),
          ]),
          _vm._v(" "),
          _c("hr", { staticStyle: { "max-width": "100%" } }),
          _vm._v(" "),
          _c("span", { staticClass: "notice-note" }, [
            _vm._v("\n        " + _vm._s(_vm.notice) + "\n      "),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-wrapper" }, [
        _c(
          "form",
          {
            staticClass: "reset-pwd-form",
            on: {
              submit: function ($event) {
                $event.preventDefault()
              },
            },
          },
          [
            _c("label", [
              _c("span", { staticClass: "required-flag" }, [
                _vm._v(
                  _vm._s(_vm.$t("username")) +
                    "(" +
                    _vm._s(_vm.$t("general.emailAddress")) +
                    ")"
                ),
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.email,
                    expression: "email",
                  },
                ],
                staticClass: "text-input",
                attrs: { type: "email" },
                domProps: { value: _vm.email },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.email = $event.target.value
                  },
                },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "right-btns" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn--darkblue  radius round",
                  attrs: { type: "button", id: "forgotpwd-form-cancel" },
                  on: {
                    click: function ($event) {
                      return _vm.navBack()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("action.cancel")))]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn--orange  radius round",
                  attrs: {
                    id: "forgotpwd-form-send",
                    disabled: !_vm.emailValid || !_vm.enableSend,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.send()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("action.send")))]
              ),
            ]),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("HKLModal", {
        ref: "confirmModal",
        attrs: {
          hasCancelBtn: false,
          title: _vm.confirmHint,
          closable: true,
          afterClose: _vm.navToLogin,
        },
      }),
      _vm._v(" "),
      _c(
        "HKLModal",
        { ref: "rejectModal", attrs: { closable: true, hasCancelBtn: false } },
        [
          _c("template", { slot: "title" }, [
            _c("pre", [
              _vm._v(_vm._s(_vm.$t("settings.password.emailNotExist"))),
            ]),
          ]),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }